// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#login-form[data-v-5c5f5a84]{margin-top:1rem;margin-bottom:2rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
